/**
 * Copyright (c) 2017 CRF Box Oy. All Rights Reserved. Company Confidential.
 */
import React from 'react';
import PropTypes from 'prop-types';
import { Col } from 'react-bootstrap';
import { Time } from 'tc-client-common';

class NotePanel extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    let properties = new Map(this.props.propertyKeys.map((i) => [i.key, i.name]));
    let showDocs = 'hide';
    if (this.props.note.type === 'DOCUMENT') {
      showDocs = 'show';
    }
    return (
      <div id={this.props.id}>
        <Col md={2} xs={2}>
          <Time
            timezone={this.props.note.timezone}
            timestamp={this.props.note.timestamp}
            format={'DD MMM, YYYY, hh:mm A,'}
            offset
          />
        </Col>
        <Col md={2} xs={2}>
          {this.props.note.reporter}
        </Col>
        <Col md={8} xs={8}>
          <div id="notes-document" className={showDocs}>
            <p>
              {properties.get('documentName')}: {this.props.note.documentName}
            </p>
            <p>
              {properties.get('sectionId')}: {this.props.note.sectionId}
            </p>
          </div>
          <p>
            {properties.get('subject')}: {this.props.note.subject}
          </p>
          <p>
            {properties.get('note')}: {this.props.note.body}
          </p>
        </Col>
      </div>
    );
  }
}

NotePanel.propTypes = {
  note: PropTypes.object.isRequired,
  propertyKeys: PropTypes.array.isRequired
};

export default NotePanel;
